import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import Pagination from "../../Components/layouts/pagination";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import LoadingPage from "../../Components/layouts/loading";
import { BsJournalArrowUp } from "react-icons/bs";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import PestDiseaseTable from "./Pest Diseases/pest_disease_table";
import { MdPestControl } from "react-icons/md";
import { useSelector } from "react-redux";

const PestDisease = () => {
  const userRole = useSelector((store) => store?.login?.user?.Role);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    diseasesName: "",
    typeOfDiseases: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/pestDisease/getAllPestDisease/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.pestDiseaseCount / 50));
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <MdPestControl className="me-2" style={{ color: "brown" }} />
                  Pest/Disease
                </h2>
              </div>
              {userRole !== process.env.REACT_APP_ROLE_CLIENT && (
                <div className="col-md-4 d-none d-sm-block">
                  <div className="btn-list justify-content-end">
                    <a href={"/agronomy-pest-disease/new"}>
                      <button className="btn btn-primary">
                        <BsJournalArrowUp className="me-2 fs-2" /> ADD NEW
                      </button>
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>

                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>

                          <div className="col-12">
                            <DynamicFilterInput
                              label="Search Name:"
                              value={filters.diseasesName}
                              placeholder="search name"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  diseasesName: e.target.value,
                                })
                              }
                            ></DynamicFilterInput>
                          </div>
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Search type:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  typeOfDiseases: e.target.value,
                                })
                              }
                              value={filters.typeOfDiseases}
                            >
                              <option value="">select all</option>
                              <option value="pest">Pest</option>
                              <option value="disease">Disease</option>
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      startdate: "",
                                      enddate: "",
                                      diseasesName: "",
                                      typeOfDiseases: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Start Date:"
                            value={filters.startdate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                startdate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>

                        <div className="col-12">
                          <DynamicFilterInput
                            label="End Date:"
                            value={filters.enddate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                enddate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>

                        <div className="col-12">
                          <DynamicFilterInput
                            label="Search name:"
                            value={filters.diseasesName}
                            placeholder="search name"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                diseasesName: e.target.value,
                              })
                            }
                          ></DynamicFilterInput>
                        </div>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Search type:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                typeOfDiseases: e.target.value,
                              })
                            }
                            value={filters.typeOfDiseases}
                          >
                            <option value="">select all</option>
                            <option value="pest">Pest</option>
                            <option value="disease">Disease</option>
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    startdate: "",
                                    enddate: "",
                                    diseasesName: "",
                                    typeOfDiseases: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {data && (
                  <PestDiseaseTable
                    EX={data?.pestDisease}
                    currentPage={page}
                    itemsPerPage={50}
                  />
                )}

                <div className="btn-list justify-content-center">
                  <div className="d-lg-none d-md-none mt-3 mb-3">
                    <a href={"/agronomy-pest-disease/new"}>
                      <button className="btn btn-primary">
                        <BsJournalArrowUp className="me-2 fs-2" />
                        ADD NEW
                      </button>
                    </a>
                  </div>
                </div>

                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={data?.pestDisease?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default PestDisease;
